// ===========================================================================
/// Represents the monitored state of one of our devices. Note that these
/// do NOT have to be associated with a particular configuration item.
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    SdkDeviceIds: function() {
        return SdkDeviceIds;
    },
    SdkDevicePins: function() {
        return SdkDevicePins;
    },
    SdkDeviceType: function() {
        return SdkDeviceType;
    },
    PushButtonStates: function() {
        return PushButtonStates;
    },
    PowerSwitchStates: function() {
        return PowerSwitchStates;
    },
    PushButtonLevelMap: function() {
        return PushButtonLevelMap;
    },
    toSdkDeviceType: function() {
        return toSdkDeviceType;
    },
    SdkDeviceState: function() {
        return SdkDeviceState;
    }
});
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var SdkDeviceIds = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8
];
var SdkDevicePins = [
    0,
    1,
    2,
    3
];
var SdkDeviceType = Object.freeze({
    IoExpander: "io-expander",
    PushButton: "push-button",
    PowerSwitch: "power-switch"
});
var PushButtonStates = Object.freeze({
    Pushed: "pushed",
    Released: "released"
});
var PowerSwitchStates = Object.freeze({
    On: "on",
    Off: "off"
});
var PushButtonLevelMap = Object.freeze({
    // keys are mqtt messages
    // values are 0/1 sdk correspondance
    "released": 0,
    "pushed": 1
});
function toSdkDeviceType(name) {
    switch(name){
        case "pushButtonModule":
            return SdkDeviceType.PushButton;
        case "digitalIOModule":
            return SdkDeviceType.IoExpander;
        case "powerSwitchModule":
            return SdkDeviceType.PowerSwitch;
        default:
            console.error("Not valid vse device type.", name);
            return name;
    }
}
var SdkDeviceState = /*#__PURE__*/ function() {
    "use strict";
    function SdkDeviceState(deviceNumber) {
        _classCallCheck(this, SdkDeviceState);
        this.deviceNumber = Number(deviceNumber);
        this.deviceType = SdkDeviceType.IoExpander;
        this.isAvailable = false;
        if (isNaN(this.deviceNumber)) {
            console.error("Device number should be a number: " + deviceNumber);
        }
        this.hardwareVersion = undefined;
        this.softwareVersion = undefined;
        this.inputs = [
            0,
            0,
            0,
            0
        ];
        this.outputs = [
            0,
            0,
            0,
            0
        ];
        this.pushButtonCounts = {
            0: 0,
            1: 0
        };
    }
    var _proto = SdkDeviceState.prototype;
    _proto.setAvailabilityOfDeviceType = function setAvailabilityOfDeviceType(deviceType, isAvailable) {
        // Note (mkosarek April 18, 2022) We receive availability updates on ALL
        // devices. As such, we only update the availaility when:
        //      1) A device type becomes available
        //      2) A device type that was previously available becomes unavailable
        // We ignore the case when a device type that is unavailable becomes unavailable again.
        if (isAvailable) {
            this.deviceType = deviceType;
            this.isAvailable = true;
        } else if (deviceType === this.deviceType) {
            this.isAvailable = false;
        }
    };
    _proto.reset = function reset() {
        var _this = this;
        var pushButtons = Object.keys(this.pushButtonCounts);
        pushButtons.forEach(function(pushButton) {
            return _this.pushButtonCounts[pushButton] = 0;
        });
    };
    _proto.toJson = function toJson() {
        return {
            deviceType: this.deviceType,
            device: this.deviceNumber,
            hwVersion: this.hardwareVersion,
            swVersion: this.softwareVersion,
            isAvailable: this.isAvailable,
            pinStates: this.inputs,
            pushCount: this.pushButtonCounts,
            outputs: this.outputs,
            // Note (mkosarek April 14, 2022) For power switches, "0" means that it is on.
            // See line 227 here: https://github.com/VentionCo/mm-vention-control/blob/develop_v2/io_expander_hub/index.js
            powerSwitchState: this.outputs[0] === 0 ? PowerSwitchStates.On : PowerSwitchStates.Off
        };
    };
    return SdkDeviceState;
}();
